import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const BurstAnimation = ({ show }) => {
  if (!show) return null;

  return (
    <div className="burst-wrapper">
      <DotLottieReact
        src="/assets/animations/sparkle.lottie" // Ensure this path is correct
        autoplay
        loop={false}
        //style={{ width: 150, height: 150 }}
      />
    </div>
  );
};

export default BurstAnimation;
